import React, { Suspense } from "react";

import { SpinnerFullScreen } from "../../components/SpinnerFullScreen";
import FormsAndFolders from "./FormsAndFolders";

// const FormsAndFolders = React.lazy(() => import("./FormsAndFolders"));

export const FormsAndFoldersRouteWithLazy: React.FC = () => {
  return (
    <Suspense fallback={<SpinnerFullScreen />}>
      <FormsAndFolders />
    </Suspense>
  );
};
